import { type AxiosInstance, isAxiosError } from 'axios';

const MAX_AUTH_ATTEMPTS = 2;

export const axiosInterceptorReCaptchaRef = {
  reauthenticateViaReCaptcha: async () => {},
};

export function startInterceptingBeforeAuthClient(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (isAxiosError(error) && error.response) {
        const errorCode = error.response.data?.code;

        switch (error.response.status) {
          case 498: {
            if (errorCode === 'WEB_CHECK_IN_TOKEN_EXPIRED_ERROR') {
              const config = error.response.config as typeof error.response.config & { attempts?: number };
              await axiosInterceptorReCaptchaRef.reauthenticateViaReCaptcha();

              config.attempts = Number.isInteger(config.attempts) ? Number(config.attempts) + 1 : 1;

              if (config.attempts > MAX_AUTH_ATTEMPTS) {
                throw new Error('Too many auth attempts');
              }

              return axiosInstance(config);
            }
          }
        }
      }

      throw error;
    },
  );
}
